<template>
    <div
        :id="id"
        class="d-fab"
        :disabled="isDisabled"
        tabindex="0"
        :class="`color-${color} ${label ? 'label' : ''}`"
        @click="clickHandler"
    >
        <div v-if="iconPosition === 'before'">
            <DIcon
                v-if="!loading"
                :name="icon"
            />
            <DIcon
                v-if="loading"
                name="loading"
                class="loading"
            />
        </div>
        <span v-if="label">{{ label }}</span>
        <div v-if="iconPosition === 'after'">
            <DIcon
                v-if="!loading"
                :name="icon"
            />
            <DIcon
                v-if="loading"
                name="loading"
                class="loading"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DFab',
    props: {
        icon: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: [String, Boolean],
            required: false,
            default: ''
        },
        color: {
            type: String,
            required: false,
            default () {
                return 'primary'
            }
        },
        id: {
            type: String,
            required: false,
            default: ''
        },
        iconPosition: {
            type: String,
            required: false,
            default: 'before'
        }
    },
    emits: ['click'],
    computed: {
        isDisabled () {
            return this.disabled || this.isInLoadingState
        }
    },
    methods: {
        clickHandler () {
            if (this.isDisabled) {
                return
            }

            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
.d-fab {
    user-select: none;
    border: 0;
    display: grid;
    align-items: center;
    padding: 15px;
    border-radius: 100px;
    box-shadow: 0px 3px 12px rgba(0,0,0,0.14);
    transition: 0.2s ease-in-out all;
    max-height: 50px;

    &[disabled=true] {
        cursor: not-allowed;
        filter: grayscale(1);
    }

    &.color-primary {
        background: var(--colorPrimary);
        color: var(--colorPrimaryText);
    }
    &.color-secondary {
        background: var(--colorSecondary);
        color: var(--colorSecondaryText);
    }
    &.color-danger {
        background: var(--colorDanger);
        color: var(--colorDangerText);
    }
    &.label {
        grid-template-columns: auto 1fr;
        grid-gap: 10px;
        padding-right: 25px;
    }

    &:hover {
        cursor: pointer;

        &.color-primary {
            background: var(--colorPrimaryHover);
        }
        &.color-secondary {
            background: var(--colorSecondaryHover);
        }
        &.color-danger {
            background: var(--colorDangerHover);
        }
    }
    &:active {
        &.color-primary {
            background: var(--colorPrimaryActive);
        }
        &.color-secondary {
            background: var(--colorSecondaryActive);
        }
        &.color-danger {
            background: var(--colorDangerActive);
        }
    }
}
</style>
